
import React from 'react';
import { useCart } from './CartContext';
import shopping_cart from '../img/shopping-cart.svg';



const Cart = () => {

  const handleBackdropClick = (e) => {
    e.stopPropagation();
  };
  const { cart,
    cartLoading,
    isCartOpen, 
    toggleCart,
    handleAddToCart,
    handleDeleteFromCart,
    handleRemoveFromCart
  } = useCart();

  return (
    <>


    {isCartOpen && <div className="cart-backdrop" onClick={toggleCart}></div>}
      <div
        className={`cart-sidebar ${isCartOpen ? 'open' : ''}`}
        onClick={handleBackdropClick}
      >

      <div className="cart-header text-center">
        <div className="cart-header-div">
            <img src={shopping_cart} className='me-4'/>
            <h3>سبد خرید</h3>
        </div>
       
      </div>
      <div className='cart-items'>
        {cart.length !== 0 && cart.products.map((product,row)=>
        <div key={row} className="cart-item d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
          
          <div className='d-flex justify-content-between align-items-stretch col-12'>
            <div className='d-flex flex-column col-5'>
              <span className='product-title'>{product.name}</span>
              <span className="product-price mt-2">{product.formatted_price}</span>
              <div className='d-flex mt-2'>
                <div className='qty-cart-item d-flex justify-content-center align-items-center'>
                  <button className='btn' onClick={() => handleAddToCart(
                    {
                      id_product : product.id_product,
                      id_product_attribute : product.id_product_attribute
                    }
                  )}><i className='icon-plus-1'></i></button>
                  <span >{product.cart_quantity}</span>
                  <button className='btn' onClick={() => handleDeleteFromCart(
                    { 
                      id_product : product.id_product,
                      id_product_attribute :product.id_product_attribute
                    }
                  )}><i className='icon-minus-1'></i></button>
                </div>
                <button className='btn' onClick={() => handleRemoveFromCart(
                  {
                    id_product : product.id_product,
                    id_product_attribute : product.id_product_attribute
                  }
                )} >حذف</button>
              </div>
            </div>
            <div  className="col-7 text-left">
              <img className="" src={product.image_home_default_url} />
            </div>
          </div>
        </div>
        )}
      <span>ارسال رایگان </span>
      <span>برای فاکتور های بالای 20 میلیون تومان </span>
      <span>به سراسر ایران</span>
      
      </div>
      {cart.length !== 0 &&
      <div className='d-flex justify-content-between'>
        <span>مجموع</span>
        <span>{cart.totals.total.value}</span>
      </div>}
      <div className="cart-footer mt-4">
        <button className="btn btn-success w-100" onClick={() => (window.location.href = `${global.config.domain_url}/cart?action=show`)}>پرداخت</button>
      </div>
    </div>

    </>
  );
};

export default Cart;
